<template>
  <v-flex xs6 sm5>
    <v-text-field
      v-model="payerName"
      label="Nome do Pagador"
      persistent-hint
      single-line
    ></v-text-field>
  </v-flex>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      storePayerName: "bills/filtersPayerName"
    }),
    payerName: {
      get() {
        return this.storePayerName;
      },
      set(newPayerName) {
        this.$store.dispatch("bills/setPayerName", newPayerName);
      }
    }
  }
};
</script>